// src/context/SiteContentContext.js
import { createContext, useContext, useEffect, useState } from 'react';

const SiteContentContext = createContext({});

export const SiteContentProvider = ({ children }) => {
  const [siteContent, setSiteContent] = useState({});

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + '/siteContent.json')
      .then(res => res.json())
      .then(data => setSiteContent(data))
      .catch(err => console.error('Failed to load site content:', err));
  }, []);

  return (
    <SiteContentContext.Provider value={siteContent}>
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContentContext = () => useContext(SiteContentContext);
